export default function cardMask(no){
  return `华通银行电子账户(尾号${no.substring(no.length-4)})`
}


// WEBPACK FOOTER //
// ./src/modules/filter/bankCardMask.js